







import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		showLabel: { type: Boolean, default: true },
	},
	data() {
		return {
			storeObject: NAME,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				oc: null,
				kodKorekce: null,
				zakazkakorekcePzn: null,
				uniqCheckPrp: false,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: any) {
			return {
				value: data.ZAZNAM_ID,
				text: data.TEXT,
				oc: data.OC,
				kodKorekce: data.KOD_KOREKCE,
				zakazkakorekcePzn: data.ZAKAZKAKOREKCEPZN,
				poznamka: data.POZNAMKA,
				uniqCheckPrp: data.UNIQ_CHECK_PRP,
			};
		},
	},
});
